import { useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'
import Articles from "./articles";
import Image from '@/components/image'
import { trackArticleReadMore } from '@/lib/analytics'
const ArticleList = () => {

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <section>
      <ul>
        {
          Articles.map((article) => {
            return (
              <li
                className="article-item"
                key={article.id}
                style={{ backgroundColor: article.backgroundColor }}
              >
                <div className="article-item-content">
                  <h2 className="article-item-title">{article.title}</h2>
                  <p className="article-item-subtitle ellipsis-multiline">
                    {article.subtitle}
                  </p>
                  <Link
                    to={`/articles/${article.id}/`}
                    className="article-item-action"
                    title="Read More"
                    role="button"
                    onClick={() => trackArticleReadMore(article.id)}
                  >
                    Read More
                  </Link>
                </div>
                <Image className="article-item-image" src={article.image} />
              </li>
            );
          })
        }
      </ul>
    </section>
  );
}

export default ArticleList;
